import { useEffect } from 'react';
import { beginTrackedRequest, endTrackedRequest } from '../utils/loadingBus';

export default function LoadingOverlay({ inProgress, active }) {
  const visible = Boolean(inProgress || active);

  useEffect(() => {
    if (!visible) {
      return undefined;
    }
    beginTrackedRequest();
    return () => endTrackedRequest();
  }, [visible]);

  return null;
}
